/**
 * Visitor-side typing signal. Composer keystrokes call `signalVisitorTyping()`;
 * the shared throttle sends a `typing` frame at most every 2s and a stop frame
 * after 2.5s idle (or immediately via `stopVisitorTyping()` on send).
 *
 * The server binds the widget socket to its session token and IGNORES any
 * client-supplied sessionId (anti-spoofing), so the payload only conveys intent.
 */

import { createTypingSignaler } from '@flozic/shared/ws';
import { WS_PROTOCOL_VERSION } from '@flozic/shared/types';
import { visitorStore } from '../session/visitorStore';
import { getWidgetWs } from './useWidgetSocket';

const signaler = createTypingSignaler((isTyping) => {
  const client = getWidgetWs();
  const sessionId = visitorStore.getSnapshot().session?.id;
  if (!client || !sessionId) return;
  client.send({
    v: WS_PROTOCOL_VERSION,
    type: 'typing',
    ts: new Date().toISOString(),
    data: { sessionId, actor: 'visitor', actorId: null, channel: 'inbuilt', isTyping },
  });
});

export const signalVisitorTyping = signaler.input;
export const stopVisitorTyping = signaler.stop;
